import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { createDataTestId } from '../../utils/test/testIds';
import { Skeleton } from '../Skeleton';
import { TYPOGRAPHY_TYPE_TO_HTML_TAG, TypographyType } from './Text.constants';
import { TextWrapper } from './Text.styles';
import { isTypographyType } from './Text.utils';
import { TextProvider } from './TextContext';
import { getRandomSkeletonPercentageWidth } from './getRandomSkeletonPercentageWidth';
export const Text = forwardRef((_ref, ref) => {
  let {
    as = TypographyType.BODY,
    styledAs,
    isTruncated,
    isInlined = false,
    isBreakWord,
    color,
    fontSize,
    children,
    align,
    fontWeight,
    fontFamily,
    lineClamp,
    lineHeight,
    marginTop,
    marginRight,
    marginLeft,
    marginBottom,
    paddingTop,
    paddingRight,
    paddingLeft,
    paddingBottom,
    marginVertical,
    marginHorizontal,
    paddingVertical,
    paddingHorizontal,
    testId,
    textTransform,
    isLoading = false,
    ...restProps
  } = _ref;
  const resolvedAs = isTypographyType(as) ? TYPOGRAPHY_TYPE_TO_HTML_TAG[as] : as;
  const resolvedStyledAs = styledAs !== undefined ? styledAs : as;
  return React.createElement(TextProvider, {
    value: resolvedStyledAs,
    "data-component": "Text"
  }, React.createElement(TextWrapper, _extends({
    as: resolvedAs,
    styledAs: resolvedStyledAs,
    isTruncated: isTruncated,
    isInlined: isInlined,
    isBreakWord: isBreakWord,
    textColor: color,
    align: align,
    lineClamp: lineClamp,
    lineHeight: lineHeight,
    fontWeight: fontWeight,
    fontFamily: fontFamily,
    marginTop: marginTop,
    marginRight: marginRight,
    marginLeft: marginLeft,
    marginBottom: marginBottom,
    marginVertical: marginVertical,
    marginHorizontal: marginHorizontal,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingLeft: paddingLeft,
    paddingBottom: paddingBottom,
    paddingVertical: paddingVertical,
    paddingHorizontal: paddingHorizontal,
    ref: ref,
    fontSize: fontSize,
    textTransform: textTransform
  }, createDataTestId(testId), restProps, {
    "data-component": "Text"
  }), isLoading ? React.createElement(Skeleton, {
    width: getRandomSkeletonPercentageWidth()
  }) : children));
});